import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { AppSettings } from 'src/app/app-settings';
import { QrCodeComponent } from 'src/app/components/bloques/qr-code/qr-code.component';
import { InfoCardComponent } from 'src/app/components/shared/info-card/info-card.component';
import { ReportsService } from 'src/app/services/reports.service';

@Component({
  selector: 'app-tickets-list',
  templateUrl: './tickets-list.component.html',
  styleUrls: ['./tickets-list.component.scss']
})
export class TicketsListComponent implements OnInit {

  @Input() compra!: any;
  @Input() type!: any;
  @Output() closeAction: EventEmitter<boolean> = new EventEmitter();
  urlEvents: string = AppSettings.MEDIA_URI + '/images/events/';

  constructor(
    private dialog: MatDialog,
    private reportService: ReportsService,
  ) { }

  ngOnInit(): void {


  }

  closeTickets() {
    this.closeAction.emit(this.type);
  }

  openQr(ticket: any) {
    this.dialog.open(QrCodeComponent, {
      panelClass: 'info-dialog',
      data: { localizador: ticket.localizador }
    });
  }

  printTicket(idOrder: number) {
    this.reportService.getUrlsDownload(idOrder).subscribe({
      next: (url) => {
        let uriDownload = url['ticket_a4'];
        setTimeout(() => {
          const newWindow = window.open(uriDownload, '_blank');
          if (!newWindow || newWindow.closed || typeof newWindow.closed === 'undefined') {
            window.location.href = uriDownload;
          }
          this.openInfoCard('Se ha descargado el ticket correctamente.', false, false);
        }, 100);
      }, error: (err) => {
        this.openInfoCard('Lo sentimos, no se han podido descargar las entradas.', true, false);
      }
    })
  }

  openInfoCard(msg: string, disabledClose: boolean = false, icon: boolean = true) {
    const dialogRef = this.dialog.open(InfoCardComponent, {
      panelClass: ['info-dialog'],
      disableClose: disabledClose,
      data: {
        icon: icon,
        text: msg,
        btnCancel: false
      }
    });
  }
}
